<template>
  <div>
    <v-row>
      <v-col cols="4">
        <date-filter store="admin" periodType="past-only" />
      </v-col>
      <v-col cols="4">
        <v-select
          outlined
          clearable
          v-model="exportName"
          :items="exports"
          :menu-props="{ maxHeight: '200', zIndex: 13 }"
          label="Export"
        />
      </v-col>
      <v-col cols="8" class="d-flex">
        <v-spacer />
        <apply-filters :disabled="disableSearch" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed, onMounted, reactive, watch } from "@vue/composition-api";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";


export default {
  name: "Filters",
  components: {
    ApplyFilters,
    DateFilter,
  },
  setup(props, { emit }) {
    const { isLoading } = useAxios();
    const { store } = useProxy();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
    });

    // =>  METHODS

    // =>  COMPUTED
    const rangeDate = computed(() => store.getters["admin/getDates"]);
    const disableSearch = computed(
      () => rangeDate.value.length !== 2 || isLoading.value
    );
    const exportName = computed({
      get() {
        return store.getters["admin/getExport"];
      },
      set(e) {
        store.dispatch("admin/updateExport", e);
      },
    });

    // =>  WATCH
    watch(exportName, (newValue) => {
      if (page.isInitialized) {
        // Only update user changes, not initialization
        addQueryStringParam(
          {
            param: URL_PARAM_NAMES["ExportFilter"],
            value: newValue,
            // is_multiple: false,
            // is_integer: false,
            // is_boolean: false,
          },
        );
      }
    });

    // =>  HOOKS
    onMounted(async () => {
      await synchronizeFilterWithQueryString({
        dispatcher: "admin/updateExport",
        param: URL_PARAM_NAMES["ExportFilter"],
        value: exportName.value,
        // is_multiple: false,
        // is_integer: false,
        // is_boolean: false,
        // dependsOn: undefined,
      });

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      disableSearch,
      exportName,
      exports: [
        {
          text: "Nb. d'articles / site",
          value: "articles_count_by_site",
        },
        {
          text: "Sessions / site / mois",
          value: "sessions_by_site_by_month",
        },
        {
          text: "Liste des articles",
          value: "articles_list",
        },
        {
          text: "Search console Discover",
          value: "search_console_discover",
        },
        {
          text: "Concurrence : Nb Articles / j (scan newsRadar)",
          value: "concurrency_nb_posts_per_day",
        },
      ],
    };
  },
};
</script>

<style></style>
